<template>
    <img src="/images/logo.png" alt="Logo Brasileirão Brokers" class="max-w-[50vh] sm:hidden " />

    <img src="/images/logo-invertido.png" alt="Logo Brasileirão Brokers" class="w-full pb:hidden" />
</template>
